export default __webpack_public_path__ + "pgnv-assets/da27044e9b245fbc0025f32c49ff3248.svg";